export default {
  install(Vue){
    Vue.filter('timeAgo',(date, accurate = true)=>{
      if (date) {
        return dsf.date.timeAgo(date, accurate)
      }
      return '';
    })
  }
}